import React, {useContext, useMemo} from 'react';
import {Link, List, ListItem, Typography} from "@mui/material";
import {OrgCustomizationContext} from "../../OrgCustomizationProvider";
import {Trans} from "react-i18next";
import {AppContext} from "../../../contexts/AppContextProvider";

const ThirdPartyProductError = () => {
    const {t, tns, language} = useContext(OrgCustomizationContext);
    const {countryCode} = useContext(AppContext);
    const pearlHref = useMemo(() => {
        switch (language) {
            case 'en':
                return 'pearl_en.pdf'
            default:
                return 'pearl_en.pdf'
        }
    }, [language])
    const creosHref = useMemo(() => {
        switch (language) {
            case 'en':
                return 'creos_en.pdf'
            case 'fr':
                return 'creos_fr.pdf'
            default:
                return 'creos_en.pdf'
        }
    }, [language])
    const otherHref = useMemo(() => {
        switch (countryCode) {
            case 'en':
                return 'other_en.pdf'
            case 'jp':
                return 'third_party_japan.docx'
            default:
                return 'other_en.pdf'
        }
    }, [language])

    return (
        <>
            <Typography variant='body1'>
                {t(countryCode === 'jp' && language === 'ja' ? 'third_party_exception_p1_jp' : 'third_party_exception_p1')}
            </Typography>

                        <List>
                
                    {countryCode !== 'jp' && (
                    <ListItem>
                        <Trans i18nKey={tns('third_party_exception_nobel_pearl')}>
                            -
                            <Link href={pearlHref} sx={{color: 'primary.main', marginLeft: '3px'}}>
                                -
                            </Link>
                            -
                        </Trans>
                    </ListItem>
                    ) }
                

                
                    {countryCode !== 'jp' && (
                    <ListItem>
                        <Trans i18nKey={tns('third_party_exception_creos')}>
                            -
                            <Link href={creosHref} sx={{color: 'primary.main', marginLeft: '3px'}}>
                                -
                            </Link>
                            -
                        </Trans>
                        </ListItem>
                    ) }
                

                <ListItem>           
                        <Trans i18nKey={tns('third_party_exception_other')}>
                            -
                            <Link href={otherHref} sx={{color: 'primary.main', marginLeft: '3px'}}>
                                -
                            </Link>
                            -
                        </Trans>
                </ListItem>
            </List>
        </>
    )
}

export default ThirdPartyProductError
